"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled = __importStar(require("./styled"));
const ResponsiveColumns = ({ children, columns = 12, noHorizontalPaddings, noPaddings, imageWithTextOverlayBlock, fullWidthLayout }) => {
    const mdCols = columns < 6 ? 6 : columns;
    return (react_1.default.createElement(styled.Col, { noHorizontalPaddings: noHorizontalPaddings, noPaddings: noPaddings, col: 12, md: mdCols, lg: columns, imageWithTextOverlayBlock: imageWithTextOverlayBlock, columns: columns, fullWidthLayout: fullWidthLayout }, children));
};
exports.default = ResponsiveColumns;
